import { Translation, TranslocoLoader } from '@ngneat/transloco';
import { Observable, from } from 'rxjs';

export class WebpackTranslateLoader implements TranslocoLoader {
  getTranslation(lang: string): Observable<Translation> {
    return from(import(`../../../assets/i18n/${lang}.json`)) as Observable<Translation>;
  }
}
